import ApplePay from './ApplePay';

export default ApplePay;
